export default __webpack_public_path__ + "static/bouh-d97db534db7d6cec1d126038e724a030.png";